export default "__VITE_ASSET__BanCj_$w__"